import React, { useState } from 'react';
import {
  Home,
  Users,
  Wifi,
  Tv,
  Waves,
  Bed,
  Car,
  Toilet,
  CookingPot,
  Flower,
  Book,
  Refrigerator,
} from 'lucide-react';

function PriceCard({ title, features, t, language }) {
  const iconMap = {
    WiFi: <Wifi className="w-4 h-4" />,
    Tv: <Tv className="w-4 h-4" />,
    Refrigerator: <Refrigerator className="w-4 h-4" />,
    CookingPot: <CookingPot className="w-4 h-4" />,
    Bed: <Bed className="w-4 h-4" />,
    Car: <Car className="w-4 h-4" />,
    Toilet: <Toilet className="w-4 h-4" />,
    Home: <Home className="w-4 h-4" />,
    Users: <Users className="w-4 h-4" />,
    Waves: <Waves className="w-4 h-4" />,
    Flower: <Flower className="w-4 h-4" />,
    Book: <Book className="w-4 h-4" />,
  };
  // Initialize with 'regularPeriod'
  const [currentPeriod, setCurrentPeriod] = useState('regularPeriod');

  const handlePeriodClick = () => {
    setCurrentPeriod((prev) =>
      prev === 'holidayPeriod' ? 'regularPeriod' : 'holidayPeriod'
    );
  };

  return (
    <div className="bg-[--c-verylight] rounded-2xl shadow-xl p-6">
      <div
        onClick={handlePeriodClick}
        className={`${
          currentPeriod === 'holidayPeriod' ? 'bg-accent' : 'bg-second'
        } cursor-pointer transition-transform duration-300 hover:-translate-y-2 inline-block px-3 py-1 rounded-xl text-sm font-semibold mb-3`}
      >
        {currentPeriod === 'holidayPeriod' ? t.holidayPeriod : t.regularPeriod}
      </div>
      <p>
        {currentPeriod === 'regularPeriod' && <></>}
      </p>
      <h2 className="text-2xl font-bold mb-2 text-[--c-dark]">{title}</h2>
      <div className="mb-4">
        {currentPeriod === 'holidayPeriod' ? (
          <div className="text-center bg-red-50 p-3 rounded-lg">
            <p className="text-xl text-[--c-main]">
              {t.holidayDates.map((date, index) => (
                <div key={index}>{date}</div>
              ))}
            </p>
            <p className="text-2xl font-bold text-[--c-accent]">
              {t.holidayPrice}
            </p>
            <p className="text-xl text-[--c-main]">
              {t.checkIn} | {t.checkOut}
            </p>
          </div>
        ) : (
          <div className="space-y-2">
            <div className="bg-blue-50 p-3 rounded-lg text-center">
              <p className="text-2xl font-bold text-[--c-dark-accent]">
                {/* Always display the regular night price */}
                {t.regularNightPrice}
              </p>
              <p className="text-xl text-[--c-main]">
                per night (min. 4 nights)
              </p>
            </div>
            <div className="bg-green-50 p-3 rounded-lg text-center">
              <p className="text-2xl font-bold text-[--c-dark-accent]">
                {t.weekendPrice}
              </p>
              <p className="text-xl text-[--c-main]">{t.weekendTime}</p>
            </div>
          </div>
        )}
      </div>
      <div className="gap-x-10 text-sm grid lg:grid-cols-2 justify-center content-start">
        {features[language].map((feature, index) => (
          <div
            key={index}
            className="flex items-center text-[--c-main] w-[200px]"
          >
            <span className="mr-2">{iconMap[features.icons[index]]}</span>
            <span className="text-lg">{feature}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function Pricing({ t, apartments, language }) {
  return (
    <div className="py-12 px-4">
    <div className="max-w-7xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto justify-center">
        {apartments &&
          apartments
            .filter(
              (apartment) =>
                apartment.mainFacts && apartment.name['en'] !== 'An oasis to enjoy'
            )
            .map((apartment, index) => (
              <div
                key={apartment.id}
                className={index === 2 ? 'md:col-span-2 md:justify-self-center' : ''}
              >
                <PriceCard
                  title={apartment.name[language]}
                  description={apartment.description[language]}
                  language={language}
                  features={apartment.mainFacts}
                  t={t}
                />
              </div>
            ))}
      </div>
    </div>
  </div>
  );
}


export default Pricing;
